import { render, staticRenderFns } from "./icon-check.vue?vue&type=template&id=11152770"
import script from "./icon-check.vue?vue&type=script&lang=ts"
export * from "./icon-check.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports